// --- START FILE: ./my-project/src/App.vue ---
<template>
  <component :is="layout">
    <router-view />
  </component>
  <!-- ADD THIS LINE -->
  <GlobalModal />
</template>

<script>
import { useUserStore } from '@/stores/user'
import { mapState } from 'pinia'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
// ADD THIS IMPORT
import GlobalModal from '@/components/GlobalModal.vue'

export default {
  // ADD THIS COMPONENT
  components: {
    GlobalModal
  },
  data () {
    return {
      stompClient: null
    }
  },
  // ... rest of the file remains exactly the same ...
  computed: {
    layout () {
      return this.$route.meta.layout || 'NoHeaderLayout'
    },
    ...mapState(useUserStore, ['isAuthenticated'])
  },
  watch: {
    isAuthenticated: {
      immediate: true,
      handler (isNowAuthenticated) {
        if (isNowAuthenticated) {
          this.setupWebSocket?.()
        } else {
          const c = this.stompClient
          if (c && typeof c.disconnect === 'function') {
            try {
              c.disconnect(() => console.log('WebSocket disconnected.'))
            } catch (e) {
              console.warn('WS disconnect error:', e)
            }
          }
          this.stompClient = null
        }
      }
    }
  },
  created () {
    const userStore = useUserStore()
    const token = localStorage.getItem('user-token')
    if (token && !userStore.isAuthenticated) {
      console.log('App.vue: Session detected on page refresh. Fetching user data...')
      userStore.fetchUser()
    }
  },
  methods: {
    setupWebSocket () {
      if (this.stompClient && this.stompClient.connected) return
      const userStore = useUserStore()
      const socket = new SockJS(process.env.VUE_APP_WS_URL)
      this.stompClient = Stomp.over(socket)
      this.stompClient.debug = null

      this.stompClient.connect({}, () => {
        console.log('WS connected (App.vue)')
        this.stompClient.subscribe('/user/queue/notifications', this.handleNotif)

        const email = userStore.user?.email
        if (email) {
          const key = btoa(email).replace(/=+$/, '').replace(/\+/g, '-').replace(/\//g, '_')
          this.stompClient.subscribe(`/topic/user/${key}/notifications`, this.handleNotif)
        } else {
          console.warn('No email on user; cannot subscribe to broadcast credits topic')
        }
      }, (error) => console.error('WS error', error))
    },
    handleNotif (message) {
      const userStore = useUserStore()
      const body = JSON.parse(message.body)
      if (body.type === 'credits_updated') {
        userStore.setCredits(Number(body.credits))
      } else if (body.type === 'error') {
        console.warn(body.message)
      }
    }
  }
}
</script>
